import styled from 'styled-components';

export const MessageUnknownWrapper = styled.div`
    .message-body.message-body-unknown .message-text {
        background: var(--avaya_grey);
        color: var(--avaya_red);
    }
`;
